import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PublicPagesRoutingModule } from './public-pages-routing.module';
import { PoliticaDatosComponent } from './politica-datos/politica-datos.component';
import { InicioComponent } from './inicio/inicio.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { SharedModule } from '../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    PoliticaDatosComponent,
    InicioComponent,
    AboutUsComponent
  ],
  imports: [
    CommonModule,
    PublicPagesRoutingModule,
    SharedModule,
    MatIconModule
  ]
})
export class PublicPagesModule { }
